import React from "react";
import { Box, ButtonGroup } from "@mui/material";

const Index = ({
  handleChange,
  setFormError,
  ButtonData,
  formError,
  setStep,
  values,
  step,
}) => (
  <>
    <div className="justify-center">
      <p className="text-white text-center text-[24.91px] lg:text-[35.43px] leading-[38.2px] lg:leading-[54.34px] font-bold mb-8">
        I am looking for...
      </p>
      <Box className="flex justify-center items-center">
        <ButtonGroup
          orientation="vertical"
          aria-label="vertical outlined button group"
          className="gap-4"
        >
          {Object.keys(ButtonData["option1"]).map((key) => (
            <button
              key={key}
              className="items-center justify-center align-items text-white font-bold py-3 px-8 rounded border border-[#93C5FF] hover:bg-white focus:bg-white focus:text-[#2C6BB3] active:bg-white active:text-[#2C6BB3] hover:text-[#2C6BB3] hover:outline-none hover:ring-2 hover:ring-[#2C6BB3] hover:ring-opacity-50 hover:scale-110 transform transition-all duration-500 ease-in-out text-[14.91px] lg:text-[17px] leading-[21.2px]"
              onClick={() => {
                const e = {
                  target: {
                    name: "option1",
                    value: ButtonData["option1"][key],
                  },
                };
                handleChange(e);
              }}
            >
              {ButtonData["option1"][key]}
            </button>
          ))}
        </ButtonGroup>
      </Box>
    </div>

    {formError.option1 ? (
      <p className="w-full flex justify-center items-center my-4 text-lg font-semibold text-white">
        {formError.option1}
      </p>
    ) : null}

    <div className="w-full flex justify-center items-center mt-8">
      <button
        className="bg-white text-[#2C6BB3] font-bold px-8 lg:px-20 text-[23.48px] rounded-md"
        onClick={() => {
          if (values.option1) {
            if (step < 4) setStep(step + 1);
          } else {
            setFormError({
              ...formError,
              option1: "Please select one option.",
            });
          }
        }}
      >
        Next
      </button>
    </div>
  </>
);

export default Index;
